import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Typography,
  TextField,
  FormControlLabel,
  Checkbox,
  Button,
  IconButton,
} from "@material-ui/core";

import rest from "../../../rest";
import { useSelector } from "react-redux";
import CloseIcon from "@material-ui/icons/Close";
import { MySnackbar } from "../../../components/mySnackbar/MySnackbar";
import useStyles from "../../../pages/attribution/modal/ModalStyle";

const EditionModele = ({
  open,
  handleClose,
  setSelectedModelID,
  setRefresh,
  modelId,
  action,
}) => {
  const [modelName, setModelName] = useState("");
  const [isShared, setIsShared] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [nameError, setNameError] = useState(false);
  const currentUser = useSelector((state) => state.user);
  const [snack, setSnack] = useState({});
  const classes = useStyles()();

  useEffect(() => {
    if (modelId === 0) return;
    if (action === "edit") {
      rest
        .post("/benevols/getModelMail.json", { idModel: modelId })
        .then((response) => {
          if (!response.data.error) {
            setModelName(response.data.name);
            setIsShared(response.data.shared);
            setIsActive(response.data.active);
          }
        });
    }
    // eslint-disable-next-line
  }, [modelId, action]);

  const handleSubmit = (event) => {
    event.preventDefault();

    if (modelName === "") {
      setNameError(true);
      return;
    }

    rest
      .post("/benevols/editModelMail.json", {
        idModel: action === "edit" ? modelId : 0,
        action: action,
        test: "TEST",
        idUser: currentUser.User.User_ID,
        nom: modelName,
        partage: isShared,
        actif: isActive,
      })
      .then((response) => {
        if (!response.data.error) {
          setSelectedModelID(response.data.idModel);
          setRefresh((prev) => !prev);
          handleClose();
        }

        setSnack({
          message: response.data.message,
          show: true,
          severity: response.data.error ? "error" : "success",
        });
      })
      .catch((error) => {
        console.error(
          "Une erreur s'est produite lors de la création du nom du nouveau modèle :",
          error
        );
      });
  };

  return (
    <>
      <MySnackbar params={snack} />
      <Modal
        open={open}
        onClose={handleClose}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div className={classes.paper}>
          <div className={classes.header}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography variant="h6" className={classes.title}>
                {action === "create" ? "Nouveau modèle" : "Modification modèle"}
              </Typography>
              <IconButton onClick={handleClose} className={classes.closeButton}>
                <CloseIcon />
              </IconButton>
            </Box>
          </div>
          <div className={classes.content}>
            <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
              <TextField
                fullWidth
                label="Nom du modèle"
                value={modelName}
                onChange={(e) => {
                  setModelName(e.target.value);
                  setNameError(false);
                }}
                margin="normal"
                required
                error={nameError}
                helperText={nameError ? "Le nom du modèle est requis." : ""}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isShared}
                    onChange={(e) => setIsShared(e.target.checked)}
                  />
                }
                label="Partagé"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isActive}
                    onChange={(e) => setIsActive(e.target.checked)}
                  />
                }
                label="Activé"
              />
              <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}>
                <Button onClick={handleClose} sx={{ mr: 1 }}>
                  Annuler
                </Button>
                <Button type="submit" variant="contained" color="secondary">
                  Valider
                </Button>
              </Box>
            </Box>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default EditionModele;
